import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { Modal, ModalContent, ModalCloseButton, Box, Flex, FloraTypography } from '@grupoboticario/flora-react'

import { actionModalHeadingStyle } from '@/components/Modal/styles'
import { theme } from '@/utils/themes/theme'
import { businessUnitTheme } from '@/utils/themes/themes'

import * as S from './ActionModal.styles'

const ActionModal = ({ open, onOpenChange, size = 'md', children, css = {}, title = null }) => {
  const [themeProvider, setThemeProvider] = useState()
  const { pathname } = useLocation()

  useEffect(() => {
    setThemeProvider(theme(globalThis?.location?.hostname))
  }, [pathname])

  return (
    <Modal onOpenChange={onOpenChange} open={open}>
      <ModalContent css={css} size={size}>
        <Box className={businessUnitTheme[themeProvider] || ''}>
          <Flex align="center" css={S.headerCss} justify="space-between">
            {title && (
              <FloraTypography as="h3" fontSize="bodyLargeStandard" fontWeight="bold" css={actionModalHeadingStyle}>
                {title}
              </FloraTypography>
            )}
            <ModalCloseButton css={S.closeButtonCss} />
          </Flex>
          <Box css={S.bodyWrapperCss}>{children}</Box>
        </Box>
      </ModalContent>
    </Modal>
  )
}

export default ActionModal
